import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StaffCard } from '../models/staffCard';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StaffcardService {
  private paginationSource = new ReplaySubject<any>(1);
  paginationSettings$ = this.paginationSource.asObservable();

  apiUrl = environment.apiUrl;
  private staffCardSource = new ReplaySubject<any>(1);
  staffCard$ = this.staffCardSource.asObservable();
 
  constructor(private http: HttpClient) {}

   addStaffCard(staffCard: StaffCard ) {
    console.log("serviscard")
    console.log(staffCard)
    return this.http.post(this.apiUrl + 'api/StaffCard',{...staffCard });
  }
  getAllStaffCard(queryParams = {currentPage: 1, itemsPerPage: null, fullNameQuery: '',enterQuery: null,roomNameQuery: '' }) {
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('enterQuery', queryParams.enterQuery);
    params = params.append('roomNameQuery', queryParams.roomNameQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'api/StaffCard/Search',{params, observe: 'response'}).pipe(map((staffCard:any) => {
      if(staffCard) {
        this.paginationSource.next(JSON.parse(staffCard.headers.get('pagination')));
        this.staffCardSource.next(staffCard.body);
      }
    })).toPromise();
  }
  editStaffCard(staffCard) {
    
    return this.http.put(`${this.apiUrl}api/StaffCard/${staffCard.id}`,staffCard);
    
} 
deleteStaffCard(id) {
  return this.http.delete(`${this.apiUrl}api/StaffCard/${id}`);
}

}